import { Routes } from '@angular/router';
import { LeagueRootComponent } from './league-root.component';
import {
  NEWS_DETAIL_KEY,
  ROUTE_LEAGUE_ABOUT,
  ROUTE_LEAGUE_CONTACTS,
  ROUTE_LEAGUE_DOCUMENTS,
  ROUTE_LEAGUE_MEDIA,
  ROUTE_LEAGUE_TOURNAMENTS,
  ROUTE_MEDIA_PARAM_KEY,
  ROUTE_NEWS_DETAIL, ROUTE_NEWS_ROOT, ROUTE_VIDEO_ROOT, VIDEO_DETAIL_KEY
} from '@config/routing-map';
import { LeagueMediaComponent } from './league-media/league-media.component';
import { LeagueMediaResolver } from './league-media/league-media.resolver';
import { LeagueTournamentsComponent } from './league-tournaments/league-tournaments.component';
import { LeagueTournamentsResolver } from './league-tournaments/league-tournaments.resolver';
import { LeagueNewsDetailComponent } from './league-news-detail/league-news-detail.component';
import { LeagueNewsDetailResolver } from './league-news-detail/league-news-detail.resolver';
import { LeagueAboutComponent } from './league-about/league-about.component';
import { LeagueContactsComponent } from './league-contacts/league-contacts.component';
import { LeagueMediaDetailComponent } from './league-media/league-media-detail.component';
import { LeagueMediaDetailResolver } from './league-media/league-media-detail.resolver';
import { DialogPageComponent } from '@mtgame/ui';
import { getLeagueMediaRoute } from '@config/routes';
import { LeagueNewsListComponent } from './league-news-list/league-news-list.component';
import { LeagueNewsResolver } from './league-news-list/league-news.resolver';
import { NotFoundComponent } from '../not-found.component';
import { LeagueVideoListComponent } from './league-video-list/league-video-list.component';
import { LeagueVideoListResolver } from './league-video-list/league-video-list.resolver';
import { LeagueVideoDetailComponent } from './league-video-detail/league-video-detail.component';
import { LeagueVideoDetailResolver } from './league-video-detail/league-video-detail.resolver';
import { LeagueDocumentsComponent } from './league-documents/league-documents.component';
import { LeagueDocumentsResolver } from './league-documents/league-documents.resolver';

export const ROUTES: Routes = [
  {
    path: '',
    component: LeagueRootComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./league-home/league-home.module').then(m => m.LeagueHomeModule)
      },
      {
        path: `${ROUTE_NEWS_ROOT}`,
        component: LeagueNewsListComponent,
        resolve: {
          data: LeagueNewsResolver
        }
      },
      {
        path: `${ROUTE_NEWS_DETAIL}/:${NEWS_DETAIL_KEY}`,
        component: LeagueNewsDetailComponent,
        resolve: {
          news: LeagueNewsDetailResolver
        }
      },
      {
        path: ROUTE_LEAGUE_MEDIA,
        component: LeagueMediaComponent,
        resolve: {
          data: LeagueMediaResolver
        },
        children: [
          {
            path: `:${ROUTE_MEDIA_PARAM_KEY}`,
            component: DialogPageComponent,
            data: {
              config: {
                isCloseButtonVisible: true,
                fullScreen: true,
                closeLink: getLeagueMediaRoute().join('/'),
              },
              component: LeagueMediaDetailComponent,
            },
            resolve: {
              data: LeagueMediaDetailResolver
            }
          }
        ]
      },
      {
        path: ROUTE_LEAGUE_TOURNAMENTS,
        component: LeagueTournamentsComponent,
        resolve: {
          data: LeagueTournamentsResolver
        }
      },
      {
        path: ROUTE_LEAGUE_ABOUT,
        component: LeagueAboutComponent,
      },
      {
        path: ROUTE_LEAGUE_CONTACTS,
        component: LeagueContactsComponent,
      },
      {
        path: ROUTE_LEAGUE_DOCUMENTS,
        component: LeagueDocumentsComponent,
        resolve: {
          data: LeagueDocumentsResolver
        }
      },
      {
        path: ROUTE_VIDEO_ROOT,
        component: LeagueVideoListComponent,
        resolve: {
          data: LeagueVideoListResolver
        }
      },
      {
        path: `${ROUTE_VIDEO_ROOT}/:${VIDEO_DETAIL_KEY}`,
        component: LeagueVideoDetailComponent,
        resolve: {
          data: LeagueVideoDetailResolver
        }
      }
    ]
  },
  {
    path: '404',
    component: NotFoundComponent
  }
];
